import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { BsModalService } from 'ngx-bootstrap/modal';
import { localStorageService } from './localstorage.service';
import { environment } from 'src/environments/environment';
import { SharedService } from './shared.service';
import { ReloadErrorModalComponent } from '../shared/reload-error-modal/reload-error-modal.component';

// Statuses that mean the server couldn't be reached at all (network down / gateway errors)
const SERVER_UNREACHABLE_STATUSES = [0, 502, 503, 504];

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {
  cache_data: any;
  reloadModalOpen = false;

  constructor(
    private _local: localStorageService, private _shared: SharedService, private modalService: BsModalService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {
    if (!this._local.customGetItem('user')) {
      this._shared.device_id();
    }
    const currentLanguage = this.gt_get_cookie('googtrans').split('/').pop();
    const clckData: any = this.get_clck();

    const headers = new HttpHeaders({
      device_type: environment.device_type,
      app_type: environment.app_type,
      app_version: environment.app_version,
      device_token: environment.device_token,
      device_id: this._local.customGetItem('user'),
      environment: environment.environment,
      Authorization: this._local.customGetItem('token') || ''
    })
    req = req.clone({ headers });
    if (req.method.toLowerCase() === 'post') {
      req = req.clone({ headers: req.headers.set('x-client-url', window.location.href) });
    }
    const timezone = this._local.customGetItem('timezone') || this._shared.getCurrentTimezone();;
    if (this._local.customGetItem('userProfileData')) {
      const userProfile = this._local.customGetItem('userProfileData');
      const clientVersion = this._local.customGetItem('client_version');
      if (userProfile && userProfile['doctor_id']) {
        req = req.clone({
          headers: req.headers.append('x-doctor-id', userProfile['doctor_id'] ? userProfile['doctor_id'] + '' : '')
        });
      }
      if (clientVersion) {
        req = req.clone({
          headers: req.headers.append('x-client-version', clientVersion)
        });
      }
    }

    req = req.clone({
      headers: req.headers.append('x-lan-code', currentLanguage || 'en')
    });

    req = req.clone({
      headers: req.headers.append('timezone', timezone)
    });

    if (clckData) {
      req = req.clone({
        headers: req.headers.append('x-clck-id', String(clckData[1]))
      })
    }

    return next.handle(req)
      .pipe(
        tap((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            const data = event.body;
          }
        }),
        catchError((error: any) => {
          if (error instanceof HttpErrorResponse && SERVER_UNREACHABLE_STATUSES.includes(error.status)) {
            this.showReloadModal();
          }
          return throwError(() => error)
        })
      );
  }

  private showReloadModal() {
    // Avoid stacking multiple modals when several requests fail at once
    if (this.reloadModalOpen) return;
    this.reloadModalOpen = true;

    const modalRef = this.modalService.show(ReloadErrorModalComponent, {
      class: 'modal-dialog-centered mxw-450 reload-error-modal-dialog',
      ignoreBackdropClick: true,
      keyboard: false
    });
    modalRef.onHidden?.subscribe(() => {
      this.reloadModalOpen = false;
    });
  }

  private gt_get_cookie(cname: string) {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  private get_clck() {
    const decodedCookie = decodeURIComponent(document.cookie);

    const ca = decodedCookie.split(';');
    const d = ca.find(i => {
      let clck = i.includes('_clck');
      return clck;
    });
    const clck = d && d.split('=')
    return clck;
  }
}

